import{a as t}from"./chunk-CSSOPAY3.js";import{a as o,b as i,m as r}from"./chunk-HBP5N4FR.js";r();import a from"react";var p=e=>a.createElement(t,i(o({},e),{title:e.title||"Confirm on Ledger",className:e.className||"dapp-ledger-modal"}));export{p as a};
//# sourceMappingURL=chunk-JR6NRUWF.js.map
